<!--RLV:06Jul2022-->

<template>
    <div v-if="loadComponent">
        <v-form>
            <v-container>
                <h1>Work Schedule</h1>

                <v-row>
                    <v-col cols="6" sm="6" md="6" :class="classPadding">
                        <v-text-field label="ES Grouping"
                                      v-model="workSchedule.esGrpCode"
                                      :class="classPadding"
                                      clearable
                                      readonly
                                      @click:clear="clearESGrpCode">
                            <template slot="append">
                                <v-icon @click.stop="searchESGrpCode">mdi-magnify</v-icon>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" :class="classPadding">
                        <v-text-field label="Holiday Calendar ID"
                                      v-model="workSchedule.holiCalendCode"
                                      :class="classPadding"
                                      clearable
                                      readonly
                                      @click:clear="clearHoliCalendCode">
                            <template slot="append">
                                <v-icon @click.stop="searchHoliCalendCode">mdi-magnify</v-icon>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" sm="6" md="6" :class="classPadding">
                        <v-text-field label="PS Grouping"
                                      v-model="workSchedule.psGroupCode"
                                      :class="classPadding"
                                      clearable
                                      readonly
                                      @click:clear="clearPSGrpCode">
                            <template slot="append">
                                <v-icon @click.stop="searchPSGrpCode">mdi-magnify</v-icon>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" :class="classPadding">
                        <v-text-field label="Timekeep Group"
                                      v-model="workSchedule.groupCode"
                                      :class="classPadding"
                                      clearable
                                      readonly
                                      @click:clear="clearGroupCode">
                            <template slot="append">
                                <v-icon @click.stop="searchGroupCode">mdi-magnify</v-icon>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
                        <v-btn color="success"
                               :loading="isSaving"
                               :class="classPadding"
                               @click.stop="save"
                               v-if="userAccess.add >= 1">Save</v-btn>
                    </v-col>
                </v-row>

            </v-container>
        </v-form>

        <v-container>
            <pagination :key="componentKey">
                <template slot="actions" slot-scope="{ item }">
                    <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
                        <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn @click.stop="deleteItem(item)"
                           text
                           icon
                           v-if="userAccess.delete >= 1">
                        <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </pagination>

            <v-dialog v-model="editDialog" width="900" persistent>
                <v-card>
                    <v-card-title>
                        <span class="headline">Edit</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6" md="6" :class="classPadding">
                                <v-text-field label="ES Grouping"
                                              v-model="editWorkSchedule.esGrpCode"
                                              :class="classPadding"
                                              clearable
                                              readonly
                                              @click:clear="clearESGrpCode">
                                    <template slot="append">
                                        <v-icon @click.stop="searchESGrpCode">mdi-magnify</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" :class="classPadding">
                                <v-text-field label="Holiday Calendar ID"
                                              v-model="editWorkSchedule.holiCalendCode"
                                              :class="classPadding"
                                              clearable
                                              readonly
                                              @click:clear="clearHoliCalendCode">
                                    <template slot="append">
                                        <v-icon @click.stop="searchHoliCalendCode">mdi-magnify</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" sm="6" md="6" :class="classPadding">
                                <v-text-field label="PS Grouping"
                                              v-model="editWorkSchedule.psGroupCode"
                                              :class="classPadding"
                                              clearable
                                              readonly
                                              @click:clear="clearPSGrpCode">
                                    <template slot="append">
                                        <v-icon @click.stop="searchPSGrpCode">mdi-magnify</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="6" :class="classPadding">
                                <v-text-field label="Timekeep Group"
                                              v-model="editWorkSchedule.groupCode"
                                              :class="classPadding"
                                              clearable
                                              readonly
                                              @click:clear="clearGroupCode">
                                    <template slot="append">
                                        <v-icon @click.stop="searchGroupCode">mdi-magnify</v-icon>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click.stop="editDialog = false">Close</v-btn>
                        <v-btn text
                               color="success"
                               @click.stop="update"
                               :loading="isUpdating"
                               v-if="userAccess.update >= 1">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>

        <v-dialog v-model="esGrpCodeDialog" width="900">
            <v-card>
                <v-card-title>
                    <span class="headline">ES Grouping</span>
                </v-card-title>
                <v-card-text>
                    <ESGrouping :show-title="false" :show-dense="false">
                        <template slot="actions" slot-scope="{ item }">
                            <v-btn @click.stop="selectESGrpCode(item)" text>Select</v-btn>
                        </template>
                    </ESGrouping>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click.prevent="esGrpCodeDialog = false" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="holiCalendCodeDialog" width="900">
            <v-card>
                <v-card-title>
                    <span class="headline">Holiday Calendar ID</span>
                </v-card-title>
                <v-card-text>
                    <HoliCalendar :show-title="false" :show-dense="false">
                        <template slot="actions" slot-scope="{ item }">
                            <v-btn @click.stop="selectHoliCalendCode(item)" text>Select</v-btn>
                        </template>
                    </HoliCalendar>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click.prevent="holiCalendCodeDialog = false" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="psGrpCodeDialog" width="900">
            <v-card>
                <v-card-title>
                    <span class="headline">PS Grouping</span>
                </v-card-title>
                <v-card-text>
                    <PSGrouping :show-title="false" :show-dense="false">
                        <template slot="actions" slot-scope="{ item }">
                            <v-btn @click.stop="selectPSGrpCode(item)" text>Select</v-btn>
                        </template>
                    </PSGrouping>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click.prevent="psGrpCodeDialog = false" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="groupCodeDialog" width="900">
            <v-card>
                <v-card-title>
                    <span class="headline">Timekeep Group</span>
                </v-card-title>
                <v-card-text>
                    <GroupCode :show-title="false" :show-dense="false">
                        <template slot="actions" slot-scope="{ item }">
                            <v-btn @click.stop="selectGroupCode(item)" text>Select</v-btn>
                        </template>
                    </GroupCode>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click.prevent="groupCodeDialog = false" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Pagination from "./Pagination";
    import userAccessMixin from "../../../../../mixins/userAccessMixin";
    import ESGrouping from "../esgrouping/Pagination";
    import HoliCalendar from "../holiCalendar/Pagination";
    import PSGrouping from "../psgrouping/Pagination";
    import GroupCode from "../../../general/tks-group/List";
    const API_ENDPOINT = "/api/workSchedule";

    export default {
        metaInfo: {
            title: "Work Schedule",
            titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
        },
        mixins: [userAccessMixin],
        components: {
            Pagination,
            ESGrouping,
            HoliCalendar,
            PSGrouping,
            GroupCode
        },
        data: () => ({
            classPadding: "my-0 py-0",
            isSaving: false,
            isUpdating: false,
            workSchedule: {},
            editWorkSchedule: {},
            componentKey: 0,
            esGrpCodeDialog: false,
            holiCalendCodeDialog: false,
            psGrpCodeDialog: false,
            groupCodeDialog: false,
            editDialog: false
        }),

        methods: {
            save() {
                this.isSaving = true;
                this.$axios
                    .post(`${API_ENDPOINT}`, this.workSchedule)
                    .then(({ data }) => {
                        this.$toast.success(data.message);
                        this.reset();
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            },
            reset() {
                this.workSchedule = {};
                this.forceRerender();
                this.editDialog = false;
            },
            forceRerender() {
                this.componentKey += 1;
            },

            edit(item) {
                var rel = Object.assign({}, item);

                this.editWorkSchedule = rel;
                this.editDialog = true;
            },
            update() {
                this.isUpdating = true;

                this.$axios
                    .put(`${API_ENDPOINT}`, this.editWorkSchedule)
                    .then(({ data }) => {
                        this.$toast.success(data.message);
                        this.reset();
                    })
                    .catch(({ response }) => {
                        this.$toast.error(response.data.message);
                    })
                    .finally(() => {
                        this.isUpdating = false;
                    });
            },

            deleteItem(item) {
                this.$confirm(this.$deleteConfirm, {
                    color: "error",
                    title: "Delete"
                }).then(res => {
                    if (res) {
                        this.$axios
                            .delete(`${API_ENDPOINT}/${item.id}`)
                            .then(({ data }) => {
                                this.$toast.success(data.message);
                                this.reset();
                            })
                            .catch(({ response }) => {
                                this.$toast.error(response.data.message);
                            });
                    }
                });
            },

            clearESGrpCode() {
                this.workSchedule.esGrpCode = null;
            },
            searchESGrpCode() {
                this.esGrpCodeDialog = true;
            },
            selectESGrpCode(item) {
                if (!this.editDialog) {
                    this.workSchedule.esGrpCode = item.esGrpCode;
                    this.esGrpCodeDialog = false;
                }
                else {
                    this.editWorkSchedule.esGrpCode = item.esGrpCode;
                    this.esGrpCodeDialog = false;
                }
            },

            clearHoliCalendCode() {
                this.workSchedule.holiCalendCode = null;
            },
            searchHoliCalendCode() {
                this.holiCalendCodeDialog = true;
            },
            selectHoliCalendCode(item) {
                if (!this.editDialog) {
                    this.workSchedule.holiCalendCode = item.holiCalendCode;
                    this.holiCalendCodeDialog = false;
                }
                else {
                    this.editWorkSchedule.holiCalendCode = item.holiCalendCode;
                    this.holiCalendCodeDialog = false;
                }
            },

            clearPSGrpCode() {
                this.workSchedule.psGroupCode = null;
            },
            searchPSGrpCode() {
                this.psGrpCodeDialog = true;
            },
            selectPSGrpCode(item) {
                if (!this.editDialog) {
                    this.workSchedule.psGroupCode = item.psGroupCode;
                    this.psGrpCodeDialog = false;
                }
                else {
                    this.editWorkSchedule.psGroupCode = item.psGroupCode;
                    this.psGrpCodeDialog = false;
                }
            },

            clearGroupCode() {
                this.workSchedule.groupCode = null;
            },
            searchGroupCode() {
                this.groupCodeDialog = true;
            },
            selectGroupCode(item) {
                if (!this.editDialog) {
                    this.workSchedule.groupCode = item.groupCode;
                    this.groupCodeDialog = false;
                }
                else {
                    this.editWorkSchedule.groupCode = item.groupCode;
                    this.groupCodeDialog = false;
                }
            }
        },
        created() {
            this.getUserAccessRights("WrkSched");
        }

    }

</script>
